module.exports = __webpack_public_path__ + "img/activity-tracker-error-screen.af0fd94c.png";